import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
export const EMBED_DASHBOARD_APP_IDS = {
  KITCHEN_SINK_APP_DASHBOARD_KEY: 'KITCHEN_SINK_APP_DASHBOARD_KEY',
  CUSTOMER_SUCCESS_WORKSPACE: 'CUSTOMER_SUCCESS_WORKSPACE',
  SALES_WORKSPACE: 'SALES_WORKSPACE',
  SALES_PERFORMANCE_WORKSPACE: 'SALES_PERFORMANCE_WORKSPACE',
  CAMPAIGN_PERFORMANCE: 'CAMPAIGN_PERFORMANCE',
  LANDING_PAGE_ANALYZE_TAB: 'LANDING_PAGE_ANALYZE_TAB',
  WEB_SITE_PAGE_ANALYZE_TAB: 'WEB_SITE_PAGE_ANALYZE_TAB',
  SOCIAL_ANALYZE_TAB: 'SOCIAL_ANALYZE_TAB'
};
export const EMBED_DASHBOARD_APP_CONFIG = {
  [EMBED_DASHBOARD_APP_IDS.KITCHEN_SINK_APP_DASHBOARD_KEY]: {
    getAppLink(subSpaceId) {
      const baseUrl = `/platform-dashboard-kitchen-sink/${PortalIdParser.get()}?kitchen-sink=EMBEDDED_DASHBOARD_TAB&embedded-tab=EMBEDDED_DASHBOARD_TAB`;
      return subSpaceId ? `${baseUrl}&use-sub-space=true` : baseUrl;
    },
    getName() {
      return I18n.text('embedDashboard.apps.KITCHEN_SINK_APP_DASHBOARD_KEY.name');
    },
    location: 'workspace',
    getSettingsLink(subSpaceId) {
      const baseUrl = `/platform-dashboard-kitchen-sink/${PortalIdParser.get()}?kitchen-sink=EMBEDDED_DASHBOARD_TAB&embedded-tab=SETTINGS_TAB`;
      return subSpaceId ? `${baseUrl}&use-sub-space=true` : baseUrl;
    },
    hydrateAppName(subSpaceId) {
      const name = subSpaceId ? `${this.getName()} - Sub Space` : this.getName();
      return Promise.resolve(name);
    }
  },
  [EMBED_DASHBOARD_APP_IDS.CUSTOMER_SUCCESS_WORKSPACE]: {
    getAppLink() {
      return `/customer-success/${PortalIdParser.get()}/dashboards`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.CUSTOMER_SUCCESS_WORKSPACE.name');
    },
    location: 'workspace'
  },
  [EMBED_DASHBOARD_APP_IDS.SALES_WORKSPACE]: {
    getAppLink() {
      return `/prospecting/${PortalIdParser.get()}/dashboards`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.SALES_WORKSPACE.name');
    },
    location: 'workspace',
    getSettingsLink() {
      return `/sales-workspace-settings/${PortalIdParser.get()}/dashboards`;
    }
  },
  [EMBED_DASHBOARD_APP_IDS.SALES_PERFORMANCE_WORKSPACE]: {
    getAppLink() {
      return `/sales-performance/${PortalIdParser.get()}/dashboards`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.SALES_PERFORMANCE_WORKSPACE.name');
    },
    location: 'workspace'
  },
  [EMBED_DASHBOARD_APP_IDS.CAMPAIGN_PERFORMANCE]: {
    getAppLink() {
      return `/marketing/${PortalIdParser.get()}/campaigns`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.CAMPAIGN_PERFORMANCE.name');
    },
    location: 'workspace'
  },
  [EMBED_DASHBOARD_APP_IDS.LANDING_PAGE_ANALYZE_TAB]: {
    getAppLink() {
      return `/page-ui/${PortalIdParser.get()}/management/pages/landing/analyze`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.LANDING_PAGE_ANALYZE_TAB.name');
    },
    location: 'analyze-tab'
  },
  [EMBED_DASHBOARD_APP_IDS.WEB_SITE_PAGE_ANALYZE_TAB]: {
    getAppLink() {
      return `/page-ui/${PortalIdParser.get()}/management/pages/site/analyze`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.WEB_SITE_PAGE_ANALYZE_TAB.name');
    },
    location: 'analyze-tab'
  },
  [EMBED_DASHBOARD_APP_IDS.SOCIAL_ANALYZE_TAB]: {
    getAppLink() {
      return `/social/${PortalIdParser.get()}/analyze`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.SOCIAL_ANALYZE_TAB.name');
    },
    location: 'analyze-tab'
  }
};